module.exports = __webpack_public_path__ + "static/media/iWatch.73bd6985.svg";